import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { CardModule, IconModule, KeyboardFocusModule, OutletModule, PromotionsModule, SpinnerModule } from '@spartacus/storefront';
import { GenOrderDetailShippingComponent } from "./order-detail-shipping/order-detail-shipping.component";
import { OrderDetailsModule } from '@spartacus/order/components';
import { MatExpansionModule } from '@angular/material/expansion';
import { GenCartSharedModule } from '../../cart/cart-shared/cart-shared.module';
import { GenAddToCartModule } from '../../cart/product-add-to-cart/product-add-to-cart.module';
import { GenOrderDetailItemsComponent } from './order-detail-items/order-detail-items.component';
import { GenOrderOverviewModule } from './order-overview/order-overview.module';
import { GenOrderEngineReplacementFormComponent } from './order-engine-replacement-form/order-engine-replacement-form.component';

@NgModule({
  imports: [
    CardModule,
    CommonModule,
    I18nModule,
    FeaturesConfigModule,
    PromotionsModule,
    UrlModule,
    SpinnerModule,
    RouterModule,
    OutletModule,
    KeyboardFocusModule,
    GenOrderOverviewModule,
    IconModule,
    OrderDetailsModule,
    MatExpansionModule,
    GenCartSharedModule,
    GenAddToCartModule,
    GenOrderEngineReplacementFormComponent,
  ],
  declarations: [
    GenOrderDetailShippingComponent,
    GenOrderDetailItemsComponent,
  ],
  exports: [
    GenOrderDetailShippingComponent,
    GenOrderDetailItemsComponent,
  ],
})
export class GenOrderDetailsModule { }
